import { graphql, useStaticQuery } from "gatsby"
import { useMemo } from "react"
import { useProductComputed } from "@app/hooks/useProductComputed"

export type ProductIngredient = {
  url: string
  title: string
  technicalName: string
  handle: {
    current: string
  }
  ingredientClass: any
  description: any
  image: any
}

export const useProductIngredients = (product: any) => {
  const { ingredients: handles } = useProductComputed(product)

  const { ingredients } = useStaticQuery<GatsbyTypes.ProductIngredientsQuery>(graphql`
    query ProductIngredients {
      ingredients: allSanityIngredient {
        edges {
          node {
            url
            title
            technicalName
            handle {
              current
            }
            ingredientClass: _rawIngredientClass(resolveReferences: { maxDepth: 2 })
            description: _rawDescription(resolveReferences: { maxDepth: 2 })
            image: _rawImage(resolveReferences: { maxDepth: 2 })
          }
        }
      }
    }
  `)

  const productIngredients: ProductIngredient[] = useMemo(() => {
    return handles
      ?.split(",")
      ?.map((handle: string) => ingredients?.edges?.find((edge: any) => handle === edge?.node?.handle?.current)?.node)
      ?.filter((item: any) => item)
  }, [handles, ingredients?.edges])

  return { ingredients: productIngredients }
}
